"use client";
import { getTranslation } from "@/i18n/get-translation";
import FAQ from "@components/faq/faq";

interface IFaqsData {
  id: number;
  title?: string;
  desc?: string;
}
const FaqsData: IFaqsData[] = [
  {
    id: 1,
    title: "faq1",
    desc: "faq1Ans",
  },
  {
    id: 2,
    title: "faq2",
    desc: "faq2Ans",
  },
  {
    id: 3,
    title: "faq3",
    desc: "faq3Ans",
  },
  {
    id: 4,
    title: "faq4",
    desc: "faq4Ans",
  },
  {
    id: 5,
    title: "faq5",
    desc: "faq5Ans",
  },
  {
    id: 6,
    title: "faq6",
    desc: "faq6Ans",
  },
  {
    id: 7,
    title: "faq7",
    desc: "faq7Ans",
  },
  {
    id: 8,
    title: "faq8",
    desc: "faq8Ans",
  },
  {
    id: 9,
    title: "faq9",
    desc: "faq9Ans",
  },
  {
    id: 10,
    title: "faq10",
    desc: "faq10Ans",
  },
  {
    id: 11,
    title: "faq11",
    desc: "faq11Ans",
  },
  {
    id: 10,
    title: "faq12",
    desc: "faq12Ans",
  },
];

interface IFAQsSection {
  locale: string;
}
export default function FAQsSection({ locale }: IFAQsSection) {
  const t = getTranslation(locale, "faqs");
  return (
    <section className="relative text-center xl:px-[28rem] lg:px-20 px-12 md:pt-6 pb-14 max-md:px-7">
      <div className="flex text-center max-w-[68rem] mx-auto flex-col justify-start items-stretch">
        <div className="lg:mb-16 mb-10 flex flex-col justify-start items-center gap-4">
          <h3 className="xl:text-2xl lg:text-xl text-lg   font-normal text-secondary-800">
            {t("faqsTitle")}
          </h3>
          <h3 className="xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] leading-none font-medium text-primary-800">
          {t("answersToYourQuestions")}
          </h3>
        </div>

        <div className="max-w-[80rem] w-full mb-16">
          <FAQ locale={locale} />
        </div>
        <div className="flex justify-center">
          <a
            href={`/${locale}/faq-search`}
            className="whitespace-nowrap border-[0.063rem] border-primary-700 text-primary-700 font-medium rounded-full leading-4 flex items-center px-7 py-4"
          >
            {t("viewMore")}
          </a>
        </div>
      </div>
    </section>
  );
}
